import React from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { validationAddAdminLawyer } from '../../../utils/validations';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import { createAdminLawyer } from '../../../configs/environments/firebase/firebaseApp';
import AddLawyerForm from './AddLawyerForm';
import './AddLawyer.scss'

const AddLawyer = ({
    handleShowAddLawyer,
    handleOpenFilter,
    handleClose,
    searchEvery,
    handleSnack,
    showLoading,
    hideLoading,
    isModal
}) => {

    const handleCloseState = () => {
        if (handleClose) {
            handleClose()
        }
        if (searchEvery) {
            searchEvery()
        }
    }

    const handleSubmit = async (values) => {
        console.log('values from addLawyer', values);
        showLoading()
        try {
            const res = await createAdminLawyer(values)
            hideLoading()
            console.log('res', res)
            handleSnack()
            handleCloseState()
        } catch (error) {
            hideLoading()
            console.log('error', error)
            handleCloseState()
        }
        
    }

    const formValues = {
        gender: '',
        name: '',
        firstLastName: '',
        secondLastName: '',
        phone: '',
        professionalLicense: '',
        specialties: [],
        email: '',
        password: '',
        termsAndConditions: true,
        role: 'lawyer',
        membership: {
            type: 'free'
        }
    }

    return (
        <div className={isModal ? 'addLawyerModal' : 'addLawyer'}>
            <p className={isModal ? 'addLawyerModal_title' : 'addLawyer_title'}>
                Agregar abogado
            </p>
            <Formik
                initialValues={formValues}
                validationSchema={validationAddAdminLawyer}
                onSubmit={handleSubmit}
                render={props =>
                    <AddLawyerForm
                        {...props}
                        isModal={isModal}
                        handleClose={handleClose}
                        handleOpenFilter={handleOpenFilter}
                        handleShowAddLawyer={handleShowAddLawyer}
                    />
                }
            />
        </div>
    )
}

const mapDispatchToProps = dispatch => ({
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
});

export default connect(null, mapDispatchToProps)(AddLawyer);
